
export default "/assets/information-circle-micro.927aa5ab.svg"